module.exports = __webpack_public_path__ + "img/outlander3.4dd69f12.jpeg";